import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable
({
  providedIn: 'root'
})
export class CommunicationService
{
  constructor(private httpClient: HttpClient)
  {

  }

  public doGet(urlStr: string, httpHeaders: HttpHeaders, httpParams: HttpParams, responseType: any): Observable<any>
  {
    responseType = (responseType != null) ? responseType : 'json';
    const httpOptions = { headers: httpHeaders, params: httpParams, responseType};

    return this.httpClient.get<any>(urlStr, httpOptions);
  }

  public doPost(urlStr: string, body: any, httpParams: HttpParams): Observable<any>
  {
    const httpOptions = { headers: new HttpHeaders({'Content-Type': 'application/json', Accept: 'application/json'}), params: httpParams };

    return this.httpClient.post<any>(urlStr, body, httpOptions);
  }

  public doPatch(urlStr: string, body: any, httpHeaders: HttpHeaders, httpParams: HttpParams): Observable<any>
  {
    const httpOptions = { headers: httpHeaders, params: httpParams};

    return this.httpClient.patch<any>(urlStr, body, httpOptions);
  }

  public doDelete(urlStr: string, httpHeaders: HttpHeaders, httpParams: HttpParams): Observable<any>
  {
    const httpOptions = { headers: httpHeaders, params: httpParams};

    return this.httpClient.delete<any>(urlStr, httpOptions);
  }
}
